<template>
  <div class="borrowing-box">
    <div class="borrowing-money">
      <div class="title">{{ $t("home.loanamount") }}</div>
      <div class="money">
        {{ formatNumberWithCommas(value) }}
      </div>
      <div class="select-box">
        <van-row>
          <van-col :span="3">
            <van-button icon="minus" round @click="tominus" />
          </van-col>
          <van-col :span="18">
            <div style="width: 86%; margin: 0 auto">
              <van-slider
                v-model="value"
                :step="step"
                :min="min"
                :max="max"
                @change="onChange"
                style="margin-top: 22px"
              />
            </div>
          </van-col>
          <van-col :span="3">
            <van-button icon="plus" round @click="toplus" />
          </van-col>
        </van-row>
      </div>
    </div>
    <div class="select-month">
      <div class="title">
        {{ $t("home.loanterm") }}
      </div>
      <div class="select-month-btnbox">
        <van-row>
          <van-col :span="6" v-for="(item, index) in month" :key="index">
            <van-button
              :class="monthvalue == item ? 'select-btn' : 'btn'"
              @click="changemonth(item)"
              >{{ item }} {{ $t("common.month") }}</van-button
            >
          </van-col>
        </van-row>
      </div>
      <div class="select-desc">
        <p>
          <span style="color: rgb(4 109 181)">{{ $t("home.repayment") }}</span
          >:{{ formatNumberWithCommas(paymoney) }} {{ $t("common.unit") }}
        </p>
        <p>{{ $t("home.principal") }}</p>
      </div>
      <div style="width: 96%; margin: 10px auto">
        <van-button class="select-btn" style="width: 100%" @click="sub">{{
          $t("home.Applyforloan")
        }}</van-button>
      </div>
    </div>
  </div>
</template>
<script>
import { formatNumberWithCommas } from "../../../utils/validate";
import { Toast } from "vant";
export default {
  name: "HomeBorrowingView",
  data() {
    return {
      step: "10000000",
      min: "30000000",
      max: "500000000",
      value: 30000000,
      month: [6, 12, 24, 30, 36, 48, 60],
      monthvalue: 6,
      paymoney: 0,
      lilv: 0,
      usrdata: {},
      is_bind:false,
      bank:null
    };
  },
  created() {
    this.getSetting();
    if (localStorage.getItem("token")) {
      this.getInfo();
      this.getUserBankInfo();
    }
  },
  methods: {
    checkCard(){
        return (this.usrdata.bankName
                && this.usrdata.identification
                && this.usrdata.identificationBack
                && this.usrdata.identificationFront
                && this.usrdata.identificationWithHand
                && this.usrdata.dob
                && this.usrdata.cccd
                && this.usrdata.bankName.length > 0
                && this.usrdata.identification.length > 0
                && this.usrdata.identificationBack.length > 0
                && this.usrdata.identificationFront.length > 0
                && this.usrdata.identificationWithHand.length > 0
                && this.usrdata.dob.length > 0
                && this.usrdata.cccd.length > 0)
    },
    checkInfo(){
        return (
            this.usrdata.education
            && this.usrdata.purpose
            && this.usrdata.house
            && this.usrdata.vehicle
            && this.usrdata.income
            && this.usrdata.address
            && this.usrdata.relationship
            && this.usrdata.nameRelationship
            && this.usrdata.relativesPhone
            && this.usrdata.otherName
            && this.usrdata.otherPhone
            && this.usrdata.otherRelationship
            && this.usrdata.education.length > 0
            && this.usrdata.purpose.length > 0
            && this.usrdata.house.length > 0
            && this.usrdata.vehicle.length > 0
            && this.usrdata.income.toString().length > 0
            && this.usrdata.address.length > 0
            && this.usrdata.relationship.length > 0
            && this.usrdata.nameRelationship.length > 0
            && this.usrdata.relativesPhone.toString().length > 0
            && this.usrdata.otherName.length > 0
            && this.usrdata.otherPhone.toString().length > 0
            && this.usrdata.otherRelationship.length > 0
        )
    },
    getInfo() {
      this.$http({
        method: "get",
        url: "user_info",
      }).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.usrdata = res.data
          }
        } else {
          Toast(res.msg);
        }
      });
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code == 200){
          if(res.data.is_bank){
            this.is_bind = true;
            this.bank = res.data.info.bankinfo
          }else {
            this.is_bind = false;
          }
        }else{
          Toast(res.msg);
        }
      })
    },
    sub() {
      if (!localStorage.getItem("token")) {
        this.$router.push({ name: "login" });
        return;
      }
    
      if(!(this.is_bind && this.checkCard() && this.checkInfo())){
        Toast(this.$t('home.tosaveinfo'))
        return
      }
      this.$http({
        method: "post",
        data: {
          price: this.value,
          term: this.monthvalue,
          monthlyPayment: this.paymoney,
          bank:this.bank,
          status:1
        },
        url: "addloan",
      }).then((res) => {
        if (res.code == 200) {
          Toast(res.msg);
          this.$router.push({ name: "loan" });
        } else {
          Toast(res.msg);
        }
      });
    },
    getSetting() {
      this.$http({
        method: "get",
        url: "getloansetting",
      }).then((res) => {
        if (res.code == 200) {
          if (res.data) {
            this.min = parseInt(res.data.minimum);
            this.max = parseInt(res.data.highest);
            this.step = parseInt(res.data.step_value);
            this.value = parseFloat(res.data.minimum);
            this.month = res.data.month.split(",");
            this.monthvalue = parseInt(this.month[0]);
            this.lilv = parseFloat(res.data.interest);
            this.getLx();
          }
        } else {
          Toast(res.msg);
        }
      });
    },
    getLx() {
      this.paymoney = (
        parseFloat(this.value / this.monthvalue) +
        parseFloat((this.value * this.lilv) / 100)
      ).toFixed(2);
    },
    changemonth(val) {
      this.monthvalue = parseInt(val);
      this.getLx();
    },
    formatNumberWithCommas(val) {
      return formatNumberWithCommas(val);
    },
    onChange(value) {
      this.value = value;
      this.getLx();
    },
    tominus() {
      if (this.value - this.step >= this.min) {
        this.value -= this.step;
        this.getLx();
      }
    },
    toplus() {
      if (this.value + this.step <= this.max) {
        this.value += this.step;
        this.getLx();
      }
    },
  },
};
</script>
<style scoped>
.borrowing-box {
  background-color: rgb(210 244 255 / 1);
}
.borrowing-box .borrowing-money {
  background-color: rgb(4 109 181/1);
  padding: 10px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
}
.borrowing-box .borrowing-money .title {
  text-align: center;
  color: #fff;
}
.borrowing-box .borrowing-money .money {
  border-radius: 8px;
  background-color: #fff;
  text-align: center;
  font-size: 24px;
  padding: 12px;
  margin: 10px;
}
.select-box {
  width: 90%;
  margin: 20px auto 10px auto;
  height: 44px;
  line-height: 1;
}
.select-month {
  background-color: #fff;
  color: #000;
}
.select-month .title {
  text-align: center;
  padding: 20px 10px 15px;
  font-size: 16px;
}
.select-month-btnbox {
  text-align: center;
  width: 96%;
  margin: 0 auto;
}
.select-month .btn {
  border: 1px solid rgb(4 109 181) !important;
  color: rgb(4 109 181) !important;
  border-radius: 8px;
  width: 90%;
  margin-bottom: 10px;
}
.select-month .select-btn {
  border: 1px solid rgb(4 109 181) !important;
  background-color: rgb(4 109 181) !important;
  color: #fff !important;
  border-radius: 8px;
  width: 90%;
  margin-bottom: 10px;
}
.select-desc {
  background-color: rgba(254, 127, 45, 0.1);
  padding: 12px;
  line-height: 1.8;
  width: 96%;
  margin: 10px auto;
}
</style>
